import { NgClass, NgTemplateOutlet } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HrefLinkDirective } from '@big-direkt/utils/shared';
import { LinkComponent } from './components/link/link.component';

@NgModule({
    imports: [HrefLinkDirective, NgClass, NgTemplateOutlet, RouterModule],
    exports: [LinkComponent],
    declarations: [LinkComponent],
})
export class UiLinkModule {}
